<template lang="pug">
    .play-box
        .warning(v-if='isImpossibleToPlayGame')
            svg#rotate(
                version='1.1'
                xmlns='http://www.w3.org/2000/svg'
                x='0px' y='0px' width='40px'
                height='40px' viewbox='0 0 612 612'
                style='enable-background:new 0 0 612 612;'
                xml:space='preserve'
            )
                no-phone-icon
            div
                | {{ $i18n.t('trainer.trainer_games_gameForDesktopOnly') }}
        .warning(v-if='isRotateNeeded')
            svg#rotate(
                version='1.1'
                xmlns='http://www.w3.org/2000/svg'
                x='0px' y='0px' width='40px'
                height='40px' viewbox='0 0 612 612'
                style='enable-background:new 0 0 612 612;'
                xml:space='preserve'
            )
                rotation-icon
            div
                | {{ $i18n.t('detective.detective_mobile_rotateText') }}
        template(v-if='!isImpossibleToPlayGame && !isRotateNeeded && !isLoading')
                game-header(
                    v-if="!isBattle"
                    @soundStateChanged ="headerKey = !headerKey"
                    :key="headerKey"
                    :time='getTime',
                    :slug='type',
                    :game-type='parameters && parameters.courseType',
                    :is-homework="!!exerciseId",
                )
                .play-box__game(v-if='gameStarted && !gameFinished')
                    .play-box__example
                        .container-draggable
                            .overflow-container
                                .wrapper
                                    .left-side
                                        .play-box-word-left(
                                                v-for="(word) in leftSidePuzzles"
                                                :style="getFontSize(word.word)"
                                            )
                                            img(:src="'/imgs/games/connect-puzzles/Union.png'")
                                            span {{ word.word }}
                                .wrapper
                                    draggable.right-answer-container(
                                            v-model="rightSideAnswers"
                                            v-bind="dragOptions"
                                            :move="handleMoveFromRightAnswerBox"
                                            @end="onDragEndFromRightAnswerBox"
                                        )
                                        .play-box-word-right(
                                            v-for="(word) in rightSideAnswers"
                                            :class="getWordClass(word)"
                                            :style="getFontSize(word.answer)"
                                        )
                                            template(v-if="word.answer")
                                                img(:src="'/imgs/games/connect-puzzles/Subtract.png'")
                                                span {{ word.answer }}
                            .overflow-container
                                .wrapper
                                    draggable.right-side(
                                            v-model="rightSidePuzzles"
                                            v-bind="dragOptions"
                                            :move="handleMoveFromRightPuzzles"
                                            @end="onDragEndFromRightPuzzles"
                                        )
                                        .play-box-word-right.relative(
                                            v-for="(word) in rightSidePuzzles"
                                            :style="getFontSize(word.answer)"
                                        )
                                            img(:src="'/imgs/games/connect-puzzles/Subtract.png'")
                                            span {{ word.answer }}
                    .play-box__game-buttons
                        game-info.game-info__block(
                            :score="{left: answers.good, right: answers.bad}"
                            :opponent="opponent"
                            :opponent-numbers="opponentNumbers"
                            :is-opponent-answering="isOpponentAnswering"
                            :is-from-battle="isBattle"
                            :is-olympiad="isOlympiad"
                        )
                        cs-button.play-box__next-example-button(
                            v-if="!isCorrectAnswerGiven",
                            @click="processReply()",
                            pattern="primary-outline",
                            color="blue"
                            :disabled="isDisabledProcessReplyBtn"
                        )  {{ $i18n.t('trainer.trainer_gamePlayBox_checkAnswer') }}
                        cs-button.play-box__next-example-button(
                            v-if="isCorrectAnswerGiven",
                            @click="nextExample",
                            pattern="primary-outline",
                            color="blue"
                        )  {{ $i18n.t('olympiads.olympiads_processStage_further') }}
                .play-box__end-container(v-if='gameFinished && !isOlympiad')
                    fireworks(
                        v-if="gameFinished && !isOlympiad && gameResult === 'success' "
                        :is-mobile="isMobile"
                    )
                    .play-box__reaction-container
                            .play-box__answers.play-box__answers--left
                                | {{ $i18n.t('trainer.trainer_game_wordField_yourTime') }}
                                br
                                | {{ getTime }}
                            result-image.play-box__image(:status="gameResult")
                            .play-box__answers.play-box__answers--right
                                | {{ $i18n.t('dashboard.dashboard_sidebar_statistics') }}
                                br
                                | {{ answers.good }} / {{ answers.bad }}
                    result-buttons(
                        v-if="!isBattle"
                        :exercise-id="exerciseId"
                        :games-type="parameters.courseType"
                        show-restart-button
                        @restartGame="restartGame"
                    )
                        slot
        cs-loader(v-if="!isImpossibleToPlayGame && !isRotateNeeded && isLoading" )
        calculating-answers(v-if="calculatingAnswers" :is-last-game-in-battle="isLastGameInBattle")
</template>

<script>
    /*eslint-disable*/
    import ConnectThePuzzlesGameItems from '@/api/games/connectThePuzzlesGameItems.js';
    import draggable from 'vuedraggable';
    import textScrollMixin from '../../../../utils/trainer/textScroll';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import Battle from '../../../../utils/battle/battleMixin';
    import olympiadRussianLanguageAnswerTimerMixin from '../../../../utils/olympiads/olympiadRussianLanguageAnswerTimerMixin.js';
    import { cloneDeep, shuffle } from 'lodash';
    import CsButton from '@/elements/CsButton.vue';
    import CsLoader from '@/elements/CsLoader.vue';
    import CalculatingAnswers from '../../CalculatingAnswersModal.vue';

    const DEFAULT_VOLUME = 0.6;

    function DEFAULT_DATA() {
        return {
            defaultObject: {
                answer: '',
                fixed: false,
                isCorrect: false,
                word: '',
            },
            isSecondProcessReply: true,
            leftSidePuzzles: null,
            rightSidePuzzles: null,
            rightSideAnswers: [],
            leftAnswerBoxRelatedClass: null,
            rightAnswerBoxRelatedClass: null,
            examples: null,
            clientWidth: 0,
            currentLevel: 1,
            answers: { good: 0, bad: 0 },
            isCorrectAnswerGiven: false,
            isDisabledProcessReplyBtn: false,
            leftAnswerRelatedElement: null,
            leftAnswerRelatedIndex: null,
            draggedIndexToLeftAnswers: null,
            draggedItemToLeftAnswers: null,
            draggedIndexToLeftPuzzles: null,
            draggedItemToLeftPuzzles: null,
            rightAnswerRelatedElement: null,
            rightAnswerRelatedIndex: null,
            draggedIndexToRightAnswers: null,
            draggedItemToRightAnswers: null,
            draggedIndexToRightPuzzles: null,
            draggedItemToRightPuzzles: null,
        };
    }

    export default {
        mixins: [textScrollMixin, playBoxGameMixin, Battle, olympiadRussianLanguageAnswerTimerMixin],
        created() {
            window.addEventListener('resize', this.getClientWidth);
        },
        mounted() {
            document.addEventListener('keydown', this.handleKeyPress);
        },
        data() {
            return DEFAULT_DATA();
        },
        computed: {
            dragOptions() {
                return {
                    animation: 0,
                    group: 'description',
                    disabled: false,
                    ghostClass: 'ghost',
                };
            },
            gameResult() {
                if (this.answers.good >= this.answers.bad) return 'success';
                else return 'failure';
            },
            isInfiniteAmountOfExamples() {
                return this.parameters.timeLimit || this.parameters.infinityAmountOfExamples ? 1 : 0;
            },
            isImpossibleToPlayGame() {
                const isVerticalAlign = this.windowWidth < this.windowHeight && this.windowHeight < 768;
                const isHorisontalAlign = this.windowWidth > this.windowHeight && this.windowWidth < 768;
                return (this.windowWidth < 1200 && this.isWordDefinitionsTheme) || isVerticalAlign || isHorisontalAlign;
            },
            isRotateNeeded() {
                return !this.isImpossibleToPlayGame && this.windowHeight > this.windowWidth && this.windowHeight >= 768;
            },
            isWordDefinitionsTheme() {
                return this.parameters?.theme === 'wordsDefinitions';
            },
        },
        updated() {
            if (
                this.rightSideAnswers.every(obj => obj.word !== '')
            ) {
                this.isDisabledProcessReplyBtn =
                    this.rightSideAnswers.length !== this.parameters?.amountOfPairs;
            } else {
                this.isDisabledProcessReplyBtn = true;
            }
        },
        methods: {
            handleKeyPress(event) {
                if (event.key === 'Enter' && !this.gameFinished) {
                    if (!this.isDisabledProcessReplyBtn && !this.isCorrectAnswerGiven) {
                        return this.processReply();
                    };
                    if (this.isCorrectAnswerGiven) {
                        return this.nextExample();
                    };
                }
            },
            handleMoveFromRightAnswerBox(event) {
                this.rightAnswerBoxRelatedClass = event.to._prevClass;
                if (this.rightAnswerBoxRelatedClass === 'right-answer-container') return false;
                if (event.draggedContext.element.isCorrect || !event.draggedContext.element?.word) return false;
                if (event.relatedContext.element?.isCorrect) return false;
                if (this.isSecondProcessReply && this.rightAnswerBoxRelatedClass === 'right-side') {
                    const { index, element } = event.draggedContext;
                    this.draggedIndexToRightPuzzles = index;
                    this.draggedItemToRightPuzzles = element;
                    return false;
                }
            },
            onDragEndFromRightAnswerBox() {
                if (
                    this.isSecondProcessReply &&
                    this.rightAnswerBoxRelatedClass === 'right-side' &&
                    this.draggedItemToRightPuzzles
                ) {
                    this.$set(this.rightSideAnswers, this.draggedIndexToRightPuzzles, this.defaultObject);
                    this.rightSidePuzzles.push(this.draggedItemToRightPuzzles);
                }
                this.rightAnswerBoxRelatedClass = null;
                this.draggedIndexToRightPuzzles = null;
                this.draggedItemToRightPuzzles = null;
            },
            handleMoveFromRightPuzzles(event) {
                if (event.to._prevClass === 'left-answer-container' || event.to._prevClass === 'left-side')
                    return false;
                if (event.relatedContext.element?.isCorrect) return false;
                if (this.isSecondProcessReply) {
                    this.rightAnswerRelatedElement = event.relatedContext.element;
                    this.rightAnswerRelatedIndex = event.relatedContext.index;

                    const { index, element } = event.draggedContext;
                    this.draggedIndexToRightAnswers = index;
                    this.draggedItemToRightAnswers = element;
                    return false;
                }
            },
            onDragEndFromRightPuzzles() {
                if (this.isSecondProcessReply && this.rightAnswerRelatedElement?.word === '') {
                    this.$set(this.rightSideAnswers, this.rightAnswerRelatedIndex, this.draggedItemToRightAnswers);
                    this.rightSidePuzzles.splice(this.draggedIndexToRightAnswers, 1);
                }
                this.draggedIndexToRightAnswers = null;
                this.draggedItemToRightAnswers = null;
                this.rightAnswerRelatedElement = null;
                this.rightAnswerRelatedIndex = null;
                this.soundInstance = this.$createjs.Sound.play('couplesDrop');
                this.soundInstance.volume = DEFAULT_VOLUME;
            },
            processReply(finishExample = false) {
                this.isSecondProcessReply = true;
                this.leftSidePuzzles.forEach((item, index) => {
                    if (this.rightSideAnswers[index].answer === item.answer) {
                        !item.isCorrect && this.answers.good++;
                        item.isCorrect = true;
                        this.rightSideAnswers[index].isCorrect = true;
                    } else {
                        this.answers.bad++;
                        if (!this.isOlympiad) {
                            this.rightSidePuzzles.push(this.rightSideAnswers[index]);
                        }
                    }
                });
                if (this.examples.length !== this.rightSideAnswers.length) {
                    this.answers.bad += this.examples.length - this.rightSideAnswers.length;
                }
                if (finishExample || this.isOlympiad || this.isBattle) {
                    return this.nextExample();
                }
                const copyLeftPart = cloneDeep(this.leftSidePuzzles.filter(obj => !obj.isCorrect));
                this.leftSidePuzzles = this.leftSidePuzzles.filter(obj => obj.isCorrect);
                this.leftSidePuzzles = this.leftSidePuzzles.concat(copyLeftPart);
                this.rightSideAnswers = this.rightSideAnswers.filter(obj => obj.isCorrect);
                for (let i = this.rightSideAnswers.length; i < this.parameters.amountOfPairs; i++) {
                    this.rightSideAnswers.push(this.defaultObject);
                }
                this.isCorrectAnswerGiven =
                    this.rightSideAnswers.length === this.parameters.amountOfPairs &&
                    this.rightSideAnswers.every(obj => {
                        return obj.isCorrect === true;
                    });
            },
            async nextExample() {
                this.stopAnswerTimer();
                this.currentLevel++;
                if (!this.isInfiniteAmountOfExamples && this.currentLevel > this.parameters.amountOfExamples) {
                    return this.finishGame();
                }
                this.isLoading = true;
                this.isCorrectAnswerGiven = false;
                this.isSecondProcessReply = true;
                this.rightSideAnswers = Array(this.examples.length).fill(this.defaultObject);
                this.getGameItems();
            },
            getBackgroundColor(word, flag) {
                if (word?.word) {
                    return { backgroundColor: '#1f87ff', ...this.getFontSize(flag ? word.answer : word.word) };
                } else {
                    return { backgroundColor: '#6bbd6d' };
                }
            },
            getWordClass(word) {
                if (word?.word) {
                    return 'relative';
                } else {
                    return '';
                }
            },
            getFontSize(word) {
                if (!word) {
                    return {};
                }
                const length = word.length;

                if (length <= 4) {
                    return { fontSize: 1.8 + 'em' };
                }
                if (length > 4 && length <= 7) {
                    return { fontSize: 1.5 + 'em' };
                }
                if (length > 7 && length <= 10) {
                    return { fontSize: 1.2 + 'em' };
                }
                if (length > 10 && length <= 13) {
                    return { fontSize: 0.85 + 'em' };
                }
                if (length > 13 && length <= 15) {
                    return { fontSize: 0.75 + 'em' };
                }
                if (length > 15 && length < 20) {
                    return { fontSize: 0.65 + 'em' };
                }
                if (length > 20) {
                    return { fontSize: 12 + 140 / length + 'px' };
                }
            },
            getCircleColor(word) {
                if (word?.word) {
                    return { fill: '#1f87ff' };
                } else {
                    return { fill: '#6bbd6d' };
                }
            },
            registerSounds() {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
                this.$createjs.Sound.alternateExtensions = ['mp3', 'ogg'];
                this.$createjs.Sound.registerSounds(this.soundObjects);
            },
            getGameItems() {
                ConnectThePuzzlesGameItems.getItemsByRequest({
                    isInfiniteAmountOfExamples: this.isInfiniteAmountOfExamples,
                    amountOfPairs: this.parameters.amountOfPairs,
                    type: this.parameters.theme,
                })
                    .then(data => {
                        this.examples = data.map((object, index) => ({ ...object, fixed: false, isCorrect: false }));
                        this.leftSidePuzzles = cloneDeep(shuffle(this.examples));
                        this.rightSidePuzzles = cloneDeep(shuffle(this.examples));
                        this.rightSideAnswers = Array(this.examples.length).fill(this.defaultObject);
                        this.startGame();
                        this.registerSounds();
                        this.isLoading = false;
                    })
                    .catch(e => this.showErrorMessage(e));
            },
            fetchData() {
                this.getExercise()
                    .then(() => {
                        this.getGameItems();
                    })
                    .catch(e => {
                        this.isLoading = false;
                        this.$toasted.error(this.$root.$t('errors.getting_level'));
                        this.$router.push({ name: 'dashboard' });
                    });
            },
            refreshGameStatBeforeSend() {
                this.gameStat.answers = this.answers.good;
                this.gameStat.amountOfMistakes = this.answers.bad;
                this.gameStat.attempts = this.currentLevel - 1;
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.amountOfExamples = this.parameters.amountOfExamples;
                this.gameStat.parameters = cloneDeep(this.parameters);
            },
            startGame() {
                this.gameStarted = true;
                this.startTimer();
            },
            startTimer() {
                this.startAnswerTimer();
                this.$nextTick(() => {
                    if (!this.timer) {
                        this.setTimer();
                    }
                });
            },
            finishGame() {
                this.gameFinished = true;
                this.stopTimers();
                this.soundInstance = this.$createjs.Sound.play('gameDone');
                this.sendStat();
            },
            stopTimers() {
                this.stopTimer();
                this.stopAnswerTimer();
            },
            calculatePercent() {
                let total = this.answers.good + this.answers.bad;
                if (total > 0) {
                    return parseInt((this.answers.good / total) * 100);
                }
                return 0;
            },
            beforeGameRestart() {
                Object.assign(this, DEFAULT_DATA());
            },
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this.handleKeyPress);
            window.removeEventListener('resize', this.getClientWidth);
        },
        components: {
            CsLoader,
            CsButton,
            draggable,
            CalculatingAnswers,
        },
    };
</script>

<style lang="scss" scoped>
    .play-box__example {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-grow: 5;
        flex-direction: column;
    }

    .play-box__overflow-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .container {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

    }

    .container-draggable {
        font-size: 17px;
        display: flex;
        justify-content: center;
        @include media($xlg) {
            font-size: 26px;
        }
    }

    .overflow-container {
        overflow-y: auto;
        max-height: calc(100vh - 250px);
        font-size: 19px;
        display: flex;
        justify-content: center;
        @include media($lg) {
            max-height: calc(100vh - 350px);
        }
        @include media($xlg) {
            font-size: 33px;
        }


        &::-webkit-scrollbar-track,
        &::-webkit-scrollbar-track {
            background: #fff;
        }
        &::-webkit-scrollbar,
        &::-webkit-scrollbar {
            background-color: #fff;
            width: 4px;
        }
        &::-webkit-scrollbar-thumb,
        &::-webkit-scrollbar-thumb {
            width: 4px;
            background: #fff;
        }
    }

    .play-box__end-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .play-box__reaction-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        @include media($md) {
            flex-direction: row;
        }
    }

    .play-box__answers {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        @include media($lg) {
            font-size: 32px;
            line-height: 38px;
        }
        @include media($xl) {
            font-size: 42px;
            line-height: 50px;
        }
    }

    .play-box__answers--left {
        color: $hsl-color-green-58;
        margin-left: 20px;
        @include media($lg) {
            margin-left: 35px;
        }
    }

    .play-box__answers--right {
        color: $hsl-color-green-58;
        margin-right: 20px;
        @include media($lg) {
            margin-right: 35px;
        }
    }

    .play-box__game-buttons {
        margin-top: 15px;
        display: flex;
        justify-content: center;
        gap: 20px;
    }

    .play-box__image {
        max-width: 100%;
        margin-bottom: 40px;
        @media screen and (max-width: 1200px) {
            height: 400px;
        }
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }

    .play-box__next-example-button {
        max-height: 64px;
        @include media($lg) {
            max-height: 76px;
        }
    }

    .wrapper {
        display: flex;
    }

    .left-side {
        min-width: 150px;
        max-height: 100px;
    }

    .right-side {
        padding-right: 5px;
        min-width: 150px;
        max-height: 100px;
    }

    .left-answer-container {
        min-width: 150px;
    }

    .right-answer-container {
        margin-left: -10px;
        padding-right: 5px;
        min-width: 150px;
    }

    .play-box-word-left {
        position: relative;
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;
        min-width: 100px;
        margin-top: 15px;
        margin-bottom: 15px;
        cursor: pointer;
        width: 160px;
        height: 70px;
        &:first-child {
            margin-top: 0px;
        }
        &:last-child {
            margin-bottom: 0px;
        }
        @include media($xlg) {
            margin-top: 20px;
            margin-bottom: 20px;
            width: 260px;
            height: 100px;
        }

        span {
            position: absolute;
        }
    }


    .relative {
        position: relative;
    }

    .play-box-word-right {
        display: flex;
        text-align: center;
        justify-content: center;
        align-items: center;
        min-width: 100px;
        margin-top: 15px;
        margin-bottom: 15px;
        cursor: pointer;
        width: 160px;
        height: 70px;
        &:first-child {
            margin-top: 0px;
        }
        &:last-child {
            margin-bottom: 0px;
        }
        @include media($xlg) {
            margin-top: 20px;
            margin-bottom: 20px;
            width: 260px;
            height: 100px;
        }

        span {
            position: absolute;
            margin-left: 20px;
        }
    }

    .game-info__block {
        &::v-deep .game-info__block {
            flex-direction: row;
            gap: 20px;
        }
    }
</style>
